import type { SessionContextType } from '../contexts/SessionContext';

/** Company domains. Accounts on them are Yaxle staff, never customers. */
const INTERNAL_EMAIL_DOMAINS = ['@partbay.ai', '@yaxle.com'] as const;

export const isInternalEmail = (email: string | null | undefined): boolean => {
    const normalized = (email ?? '').trim().toLowerCase();
    return INTERNAL_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain));
};

/**
 * Yaxle staff: an employee account (`isInternal`, can switch orgs) or a legacy
 * staff identity on a company domain. Display gate only; the API enforces access.
 */
export const isInternalStaff = (session: SessionContextType | undefined): boolean =>
    session?.isAuthenticated === true && (session.isInternal || isInternalEmail(session.email));
